import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { InformationPageService } from 'src/app/services/informationPage.service';
import { TranslateService } from '@ngx-translate/core';
import { BrowserStorageService } from 'src/app/services/storage.service';
import { InformationPageContent } from 'src/app/intefaces/information-page-content.interface';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-how-buy',
  templateUrl: './how-buy.component.html', encapsulation: ViewEncapsulation.None,
  styleUrls: ['./how-buy.component.scss']
})
export class HowBuyComponent implements OnInit {
  howBuyHtml: InformationPageContent = { content: ''};

  constructor(
    private pageService: InformationPageService,
    private translate: TranslateService,
    private browserStorageService: BrowserStorageService, private title: Title) { }

  ngOnInit(): void {
    this.initContent(null);
    this.translate.onLangChange.subscribe(
      lang => { this.initContent(lang.lang); }
    );
 
    this.translate.get('title_how_to_buy').subscribe({
      next: (title) => {
        this.title.setTitle(title);
      }
    });
  }

  private initContent(lang: string): void {
    if (lang == null) {
      lang = this.browserStorageService.get("_lang");
      if (lang == null || lang == '') {
        lang = 'pl';
      }
    }
    this.pageService.getInformationPage(this.pageService.PAGES.HOW_TO_BUY, lang).subscribe((response: any) => {
      this.howBuyHtml.content = response.data.page[Object.keys(response.data.page)[0]];
    });
  }

}

